/*
*   操作日志管理组件
*   zhangxianwen
*   2023-10-27
*/
import React , { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Row, Col, message, Table, Input, Select } from 'antd';
import { UjoinParams, AddRequestHeaders, DeleteCookies, winWidth } from '../../incs/FunHelper.js';

const Option = Select.Option;

class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '操作者',dataIndex: 'operation',key: 'operation',fixed: 'left',},
            {title: '操作对象',dataIndex: 'instance',key: 'instance',},
            {title: '模块', dataIndex: 'module', key: 'module', },
            {title: '动作', dataIndex: 'action', key: 'action', },
            {title: '描述', key: 'description', 
                render: (record) => record.description?record.description:'-'
            },
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time',},
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    scroll={{ x: this.props.x}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class LogOperation extends Component{
    constructor(props){
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            operation: '',
            instance: '',
            module: '',
            action: ''
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeOperation = (e) =>{this.setState({operation: e.target.value});this.search();}
    changeInstance = (e) =>{this.setState({instance: e.target.value});this.search();}
    changModule = (value) =>{this.setState({module: value});this.search();}
    changAction = (value) =>{this.setState({action: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}

    /**
     * 获取操作日志列表
     */
    getLists(){
        const _this = this;
        const params = {
            'operation': this.state.operation,
            'instance': this.state.instance,
            'module': this.state.module,
            'action': this.state.action,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}log/operations${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                    setTimeout(function(){
                        //  若获取策略失败，直接退出登录
                        DeleteCookies();
                    }, 1500);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.getLists();
    }

    render(){
        return(
            <div>
                <Row style={{ height: 60, paddingTop:10, paddingLeft:20 }}>
                    <Col span={3}>
                        <Input
                            onChange={this.changeOperation}
                            onPressEnter={this.search}
                            placeholder='操作者...'
                            value={this.state.operation}
                        />
                    </Col>
                    <Col span={5} style={{ marginLeft: 5 }}>
                        <Input
                            onChange={this.changeInstance}
                            onPressEnter={this.search}
                            placeholder='操作对象...'
                            value={this.state.instance}
                        />
                    </Col>
                    <Col span={3} style={{ marginLeft: 5 }}>
                        <Select defaultValue={''} style={{ width: '100%' }} onChange={this.changModule}>
                            <Option value=''>请选择模块</Option>
                            {
                                CNF.modules && CNF.modules.map((item) => {
                                    return <Option key={item} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={3} style={{ marginLeft: 5 }}>
                        <Select defaultValue={''} style={{ width: '100%' }} onChange={this.changAction}>
                            <Option value=''>请选择动作</Option>
                            {
                                CNF.actions && CNF.actions.map((item) => {
                                    return <Option key={item} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists 
                            dataLists={this.state.dataLists} 
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount} 
                            changeIndex={this.changeIndex} 
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default LogOperation